import { REACT_APP_ARPS_BASE_URL } from "../utils/urls";

const patchDataArps = async (data: any, uri: any) => {
  const response = await fetch(`${REACT_APP_ARPS_BASE_URL}/${uri}`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  const result = await response.json();
  return result;
};

export default patchDataArps;
